import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { PRODUCT_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class MdaSdaService {
    private readonly URL_PATH = `${PRODUCT_URL}/mda-sda`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public getAllMdaSda(params: { pageIndex: number, pageSize: number, searchValue: string }): Observable<any> {
        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize);
        if (params.searchValue && params.searchValue !== '') {
            queryParams = queryParams.set('searchValue', params.searchValue.trim());
        }
        return this.http
            .get<any>(`${this.URL_PATH}/getAllMdaSda`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public addMdaSda(data: { name: string; }): Observable<any> {
        return this.http
            .post<any>(`${this.URL_PATH}/save`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public updateMdaSda(data: { id: number; name: string; }): Observable<any> {
        return this.http
            .post<any>(`${this.URL_PATH}/updateMdaSda`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public deleteMdaSda(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.URL_PATH}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }
}
